import React from 'react'
import 'bootstrap/dist/css/bootstrap.min.css';
import { Form } from "react-bootstrap";
import { Container, Button } from "react-bootstrap";
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import OutlinedInput from '@mui/material/OutlinedInput';
import Chip from '@mui/material/Chip';
import CancelIcon from '@mui/icons-material/Cancel';
import IconButton from '@mui/material/IconButton';
import { useState } from "react";
import axios from "axios";
import ENDPOINT from '../../data/ENDPOINT';

const label = { inputProps: { 'aria-label': 'Checkbox demo' } };

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const names = [
  'IT/Technology',
  'Education/Training/Teaching',
  'IT Support & Services',
  'Internet of Things (IoT)',
  'DevOps & Automation',
  'IT Support & Services',
];


const SignupPage = () => {
  const [select, setSelect] = React.useState('');
  const theme = useTheme();
  const [personName, setPersonName] = React.useState([]);

  const handleChange = (event) => {
    setSelect(event.target.value);
    const {
      target: { value },
    } = event;
    setPersonName(typeof value === 'string' ? value.split(',') : value);
  };
  const handleDelete = (name) => {
    setPersonName((prev) => prev.filter((n) => n !== name));
  };



  const [formData, setFormData] = useState({
    name: "",
    about_organization: "",
    image: "",
    company_email: "",
    password: "",
    location: "",
    employee_strength: "",
    industry: "",
  });

  const [responseMessage, setResponseMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleAddOrganization = async () => {
    const { name, about_organization, image, company_email, password, location, employee_strength, industry } = formData;

    // Corrected employee_strength field name
    if (!name || !about_organization || !image || !company_email || !password || !location || !employee_strength || !industry) {
      alert("Please fill all fields.");
      return;
    }

    setLoading(true);
    setResponseMessage("");

    try {
      const response = await axios.post(ENDPOINT + "add-organization.php", new URLSearchParams(formData));

      const { status, message } = response.data;

      if (status === "success") {
        alert("Organization added successfully!");
        setResponseMessage(message);
      } else {
        setResponseMessage(`Error: ${message}`);
      }
    } catch (error) {
      console.error("Error adding organization:", error);
      setResponseMessage("An unexpected error occurred.");
    } finally {
      setLoading(false);
    }
  };




  return (
    <div>
      <div>
        <h2 className="text-center fw-bold m-4">Organization details</h2>
      </div>

      <Container fluid className="d-flex justify-content-center align-items-center min-vh-100 bg-light ">
        <Container className="bg-white shadow-sm rounded " style={{ maxWidth: "600px" }}>

          <div className='rounded p-3'>
            <h6>Organization name</h6>
            <input type='text' placeholder='Entre Oraganization name' name='name' value={formData.name} onChange={handleInputChange} className='rounded rounded-1 border-1 form-control'></input>
            <div className='d-flex'>
              <Checkbox {...label} defaultChecked />
              <p className='text-secondary mt-2'>I am an independent practitioner (freelancer, architect, lawyer ect.) hiring for myself and I am NOT hiring on behalf of a company.</p>
            </div>
            <Form.Group className="mb-3">
              <Form.Label>Organization Description</Form.Label>
              <Form.Control as="textarea" rows={4} name="about_organization" value={formData.about_organization} onChange={handleInputChange} placeholder="Enter description" />
            </Form.Group>
            <h6>Organization city</h6>
            <input type='text' placeholder='Enter location' name='location' value={formData.location} onChange={handleInputChange} className='rounded rounded-1 border-1 form-control'></input>


            <h6 className='mt-2'>Company email</h6>
            <input type='email' placeholder='Entre email' name='company_email' value={formData.company_email} onChange={handleInputChange} className='rounded rounded-1 border-1 form-control w-50' ></input>

            <h6 className='mt-2'>Password</h6>
            <input type='password' placeholder='Entre password' name='password' value={formData.password} onChange={handleInputChange} className='rounded rounded-1 border-1 form-control w-50' ></input>



            <h6 className='mt-2'>Industry</h6>
            <input type='text' placeholder='Entre industry' name='industry' value={formData.industry} onChange={handleInputChange} className='rounded rounded-1 border-1 form-control w-50' ></input>

            <h6 className='mt-2'> No.of employees</h6>
            <input type='number' placeholder='11-50' name='employee_strength' value={formData.employee_strength} onChange={handleInputChange} className='rounded rounded-1 border-1 form-control w-50' ></input>


            <h6 className='mt-2'> organizational logo</h6>
            <input type='text' placeholder='Entre logo URL' name='image' value={formData.image} onChange={handleInputChange} className='rounded rounded-1 border-1 form-control w-50' ></input>

            <div>
              <p className='text-secondary mt-2' style={{ fontSize: "13px" }}>Max file size: 1Mb and max resolution: 500px x 500px. File type:jpeg,jpg,png,gif,bmp</p>
            </div>
          </div>
          <div className="text-end pb-3 ">
            <button className='btn btn-primary' onClick={handleAddOrganization} disabled={loading}>
              {loading ? "Adding..." : "Add Organization"}
            </button>
            {responseMessage && <p>{responseMessage}</p>}
          </div>

        </Container>
      </Container>


    </div>
  )
}

export default SignupPage
